import classNames from 'classnames'
import React, {useEffect} from 'react'
import s from './calendar.scss'
import {CalendarProps} from './interfaces'
import {MonthlyCalendar} from './monthly'
import {MobileMonthlyCalendar} from './monthly/mobile'

const MIN_WIDTH = 750
const MIN_MOBILE_WIDTH = 280

export const Calendar = ({isMobile, loading, width}: CalendarProps) => {
  const [forceMobileLayout, setForceMobileLayout] = React.useState(false)

  useEffect(() => {
    if (!width) {
      return
    }

    const minWidth = isMobile ? MIN_MOBILE_WIDTH : MIN_WIDTH

    if (width < minWidth) {
      setForceMobileLayout(true)
    } else {
      setForceMobileLayout(false)
    }
  }, [width])

  if (loading) {
    return null
  }

  const mobile = isMobile || forceMobileLayout
  return (
    <div className={classNames(s.calendar, {[s.mobile]: mobile})} data-hook="calendar-layout">
      {mobile ? <MobileMonthlyCalendar /> : <MonthlyCalendar />}
    </div>
  )
}
